import { aquaAxiosWithCreds, callAsyncWithRetry } from '../../lib/utilityFunctions';
import {
  API_URL,
} from './endpoints';
import { handleAuthFailure } from './apiErrors';

const saveQuestSession = (quest_id, quest_session_id, content_sets_ids, content_source) =>
  callAsyncWithRetry(async () => {
    try {
      await aquaAxiosWithCreds(`${API_URL}/questSession`, {
        method: 'PUT',
        data: {
          quest_id,
          quest_session_id,
          content_sets_ids,
          content_source,
        },
      });
    } catch (error) {
      handleAuthFailure(error);
      throw error;
    }
  });

export default saveQuestSession;
